export default __webpack_public_path__ + "static/media/Quarter2.e4f6352b.png";